<div *ngIf="show()" class="alert alert-info" role="alert">
  For rapporteringspliktige hendelser trenger vi informasjon om flyets registrering, planlagt avreise- og ankomstflyplass og sted for hendelsen. Du kan angi alt i feltet nedenfor, eller fylle ut så mye som du klarer direkte i de andre feltene. Dersom du allerede har rapportert hendelsen direkte selv, gi oss beskjed om dette.
</div>
